/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".access-denied-wrapper[_ngcontent-%COMP%]{height:100%;background-color:#fcb315;display:flex;justify-content:center;align-items:center;right:0;left:0;position:fixed}.access-denied-wrapper[_ngcontent-%COMP%]   .ad-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:300px;width:100%;-o-object-fit:contain;object-fit:contain}"];
export { styles as styles };
